import { Box } from '@mui/material'
import { Seo } from '@/components/common'
import {
  ContactSection,
  FinalCtaSection,
} from '@/components/sections'

/**
 * Contact Page Component
 * Contact form and final call-to-action
 */
export const ContactPage = () => {
  return (
    <Box>
      <Seo
        title="Contact Us"
        description="Get in touch with Leru Systems for a free consultation. Let's build a website that helps your plumbing company generate more leads and customers."
        path="/contact"
      />
      <FinalCtaSection />
      <ContactSection />
    </Box>
  )
}
